export var AccountRole;
(function (AccountRole) {
    AccountRole[AccountRole["CSM"] = 1] = "CSM";
    AccountRole[AccountRole["LeadCSM"] = 2] = "LeadCSM";
    AccountRole[AccountRole["PEMOrCEM"] = 3] = "PEMOrCEM";
    AccountRole[AccountRole["CustomerAdmin"] = 4] = "CustomerAdmin";
    AccountRole[AccountRole["Member"] = 5] = "Member";
})(AccountRole || (AccountRole = {}));
//# sourceMappingURL=account-role.js.map